import { createApp } from 'vue'
import Vuex from 'vuex'
const app = createApp({})

app.use(Vuex)

export default new Vuex.Store({
  state: {
    meetingSession: null,
    myselfVideo: null,
    yourselfVideo: null,
    guest1selfVideo: null,
    guest2selfVideo: null,
    guest3selfVideo: null,
    shareContentVideo: null,
    isMicrophoneMute: true,
    speakerVolume: 0.5,
    isCameraStop: true,
    isVirtualBackgroundStop: false,
    shareTileId: null,
    isTargetAtendeeActive: false
  },
  getters: {
    meetingSession: state => state.meetingSession,
    myselfVideo: state => state.myselfVideo,
    yourselfVideo: state => state.yourselfVideo,
    guest1selfVideo: state => state.guest1selfVideo,
    guest2selfVideo: state => state.guest2selfVideo,
    guest3selfVideo: state => state.guest3selfVideo,
    shareContentVideo: state => state.shareContentVideo,
    isMicrophoneMute: state => state.isMicrophoneMute,
    speakerVolume: state => state.speakerVolume,
    isCameraStop: state => state.isCameraStop,
    isVirtualBackgroundStop: state => state.isVirtualBackgroundStop,
    shareTileId: state => state.shareTileId,
    isTargetAtendeeActive: state => state.isTargetAtendeeActive
  },
  mutations: {
    setMeetingSession (state, session) {
      state.meetingSession = session
    },
    setMyselfVideo (state, videoElm) {
      state.myselfVideo = videoElm
    },
    setYourselfVideo (state, videoElm) {
      state.yourselfVideo = videoElm
    },
    setGuest1selfVideo (state, videoElm) {
      state.guest1selfVideo = videoElm
    },
    setGuest2selfVideo (state, videoElm) {
      state.guest2selfVideo = videoElm
    },
    setGuest3selfVideo (state, videoElm) {
      state.guest3selfVideo = videoElm
    },
    setShareContentVideo (state, videoElm) {
      state.shareContentVideo = videoElm
    },
    setIsMicrophoneMute (state, bool) {
      state.isMicrophoneMute = bool
    },
    setSpeakerVolume (state, num) {
      state.speakerVolume = num
    },
    setIsCameraStop (state, bool) {
      state.isCameraStop = bool
    },
    setIsVirtualBackgroundStop (state, bool) {
      state.isVirtualBackgroundStop = bool
    },
    setShareTileId (state, tileId) {
      state.shareTileId = tileId
    },
    setIsTargetAtendeeActive (state, bool) {
      state.isTargetAtendeeActive = bool
    }
  },
  action: {
    setMeetingSession (context, session) {
      context.commit('setMeetingSession', session)
    },
    setMyselfVideo (context, videoElm) {
      context.commit('setMyselfVideo', videoElm)
    },
    setYourselfVideo (context, videoElm) {
      context.commit('setYourselfVideo', videoElm)
    },
    setGuest1selfVideo (context, videoElm) {
      context.commit('setGuest1selfVideo', videoElm)
    },
    setGuest2selfVideo (context, videoElm) {
      context.commit('setGuest2selfVideo', videoElm)
    },
    setGuest3selfVideo (context, videoElm) {
      context.commit('setGuest3selfVideo', videoElm)
    },
    setShareContentVideo (context, videoElm) {
      context.commit('setShareContentVideo', videoElm)
    },
    setIsMicrophoneMute (context, bool) {
      context.commit('setIsMicrophoneMute', bool)
    },
    setSpeakerVolume (context, num) {
      context.commit('setSpeakerVolume', num)
    },
    setIsCameraStop (context, bool) {
      context.commit('setIsCameraStop', bool)
    },
    setIsVirtualBackgroundStop (context, bool) {
      context.commit('setIsVirtualBackgroundStop', bool)
    },
    setShareTileId (context, tileId) {
      context.commit('setShareTileId', tileId)
    },
    setIsTargetAtendeeActive (context, bool) {
      context.commit('setIsTargetAtendeeActive', bool)
    }
  }
})
